// color names obtained from -> http://chir.ag/projects/name-that-color/#10101F
export const Colors = {
  GoldTips: '#deba13',
  CodGray: '#1C1C1C',
  CodGray07: 'rgba(28, 28, 28, 0.7)',
  darkerCodGray: 'rgb(10, 10, 10)',
  Gallary: '#F0F0F0',
  Rhino: '#30405f',
  Turquoise: '#2EE0E0',
  Tundora: '#414141',
  Vulcan: '#10101f',
  Woodsmoke: `#18181c`,
  Woodsmoke2: `rgb(23, 23, 28)`
};
